import type { ComponentType } from "react";
import type { AnalyticsSectionKey } from "@vekha/contracts";

type Page = ComponentType<{ section: AnalyticsSectionKey }>;
/** The page of «Аналитика» once its code is here. A lazy() component suspends on its first render even when its code is
 * already loaded, and React then holds the content back for ~300 ms (the reveal of a suspended tree is throttled; 17.10.2026:
 * «Сводка» appeared 0.3 s after everything had come). main.tsx loads the code with the page; App renders it directly then. */
let loaded: Page | null = null;
let loading: Promise<Page> | null = null;
export function loadAnalyticsPage(): Promise<Page> {
  loading ??= import("../pages/analytics").then((module) => (loaded = module.AnalyticsPage));
  return loading;
}
export const loadedAnalyticsPage = (): Page | null => loaded;
